import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Spinner, } from '@fortem-monorepo/react-ui';
export const useConfirmModal = (options) => {
    const [open, setOpen] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [action, setAction] = useState(() => async () => { });
    const toggle = (open = false) => {
        setOpen((prev) => (open !== undefined ? open : !prev));
    };
    const _Dialog = useMemo(
    // @ts-ignore
    () => (props) => {
        const { title, description, open, setOpen, action: apiAction, confirming } = _Dialog.api;
        return (_jsx(Dialog, { open: open, onOpenChange: setOpen, children: _jsxs(DialogContent, { className: "max-w-fit!", children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), description && _jsx(DialogDescription, { children: description })] }), props.children, _jsxs(DialogFooter, { children: [_jsx(Button, { variant: 'destructive', onClick: () => toggle(false), children: "Cancel" }), _jsxs(Button, { onClick: async () => {
                                    setConfirming(true);
                                    try {
                                        await apiAction();
                                        setOpen(false);
                                    }
                                    finally {
                                        setConfirming(false);
                                    }
                                }, disabled: confirming, children: [confirming && _jsx(Spinner, {}), "Confirm"] })] })] }) }));
    }, []);
    const api = {
        open,
        setOpen,
        action,
        confirming,
        ...options,
    };
    // @ts-ignore
    _Dialog.api = api;
    const withConfirmation = (action) => {
        setAction(() => action);
        setOpen(true);
    };
    return {
        Dialog: _Dialog,
        withConfirmation,
    };
};
